import { generatePath } from 'react-router-dom'
import { routes } from '@/routes'
import { AccountingCustomerCompany } from '@/types/customer-context'

export type SelectedProduct =
  | { product: 'credit' }
  | { product: 'accounting'; company_key: string }

const STORAGE_KEY = 'selected_product'
export const STORAGE_COMPANY_KEY = 'selected_company'

export function readSelectedProduct(): SelectedProduct | null {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw) as SelectedProduct
    if (parsed.product === 'credit') return { product: 'credit' }
    if (parsed.product === 'accounting' && parsed.company_key) {
      return { product: 'accounting', company_key: parsed.company_key }
    }
  } catch {
    return null
  }

  return null
}

export function writeSelectedProduct(product: SelectedProduct) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(product))
}

export function rememberSelectedCompany(company: AccountingCustomerCompany) {
  if (!company.company_key) return

  localStorage.setItem(STORAGE_COMPANY_KEY, company.company_key)
  writeSelectedProduct({
    product: 'accounting',
    company_key: company.company_key,
  })
}

export function companyRouteFor(company: AccountingCustomerCompany): string {
  if (company.deal_status === 'incomplete' && company.deal_step !== 'signed') {
    return generatePath(routes.accounting.hiring.index, {
      deal_key: company.deal_key,
    })
  }

  return routes.accounting.index
}
